<h1 class="border-bottom text-center lead">
  <ng-content></ng-content>
</h1>
